import virtualClassroomStudentRoutes from 'modules/virtualClassrooms/common/routing/studentRoutes'

const routes = {
  my: `${virtualClassroomStudentRoutes.root}/my`,
  library: `${virtualClassroomStudentRoutes.root}/library`,
  category: `${virtualClassroomStudentRoutes.root}/library/category`,
}

export default routes
